import { track } from '@amplitude/analytics-browser'

export const trackShowTimeOpen = () => track('show_time_open').promise
